import { StopOutlined, UnlockOutlined } from "@ant-design/icons";
import { App, Button } from "antd";
import { useTranslation } from "react-i18next";

import { useBlockUser } from "../model/useBlockUser";

export function BlockUserButton({ userId, blocked }: { userId: number; blocked: boolean }) {
  const { t } = useTranslation();
  const { modal, message } = App.useApp();
  const mutation = useBlockUser(userId);

  return (
    <Button
      danger={!blocked}
      icon={blocked ? <UnlockOutlined aria-hidden /> : <StopOutlined aria-hidden />}
      loading={mutation.isPending}
      onClick={() => {
        if (blocked) {
          mutation.mutate(
            { is_blocked: false },
            {
              onSuccess: () => {
                void message.success(t("users.unblockDone"));
              },
            },
          );
          return;
        }
        void modal.confirm({
          title: t("users.block"),
          content: t("users.blockConfirm"),
          okText: t("users.block"),
          okButtonProps: { danger: true },
          cancelText: t("common.cancel"),
          onOk: async () => {
            await mutation.mutateAsync({ is_blocked: true });
            void message.success(t("users.blockDone"));
          },
        });
      }}
    >
      {blocked ? t("users.unblock") : t("users.block")}
    </Button>
  );
}
